// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__2GKnO","value":"styles_value__1t62B","link":"styles_link__2uaIq","warning":"styles_warning__3Qx75"};